import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import "./index.css";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

export default function MainComponent({
  bgImage,
  logoSolution,
  desc,
  cardsComponent,
  textoContenido,
  colorTexto,
  imagenContenido,
  ordenFlex,
  textoColor,
  textoNegro,
  ordenTitulo,
  soloHeader,
  parallax = false,
  whitewash = false,
  flushBottom = false,
  bgPosition,
  lastSection = () => {},
  intermediateSection = () => {},
}) {
  return (
    <>
      <DefaultNavbar
        routes={[]}
        action={{
          type: "internal",
          route: "/",
          label: "Ir al inicio",
          color: "default",
        }}
        transparent
        sticky
        light
      />{" "}
      <MKBox
        display="flex"
        flexDirection="column"
        bgColor="white"
        gap="10vh"
        mb={flushBottom ? 0 : "5.5vh"}
      >
        <MKBox
          minHeight={{
            xs: soloHeader ? "45vh" : "55vh",
            md: soloHeader ? "55vh" : "70vh",
          }}
          width="100%"
          sx={{
            backgroundImage: whitewash
              ? `linear-gradient(rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.55)), url(${bgImage})`
              : `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: bgPosition || (parallax ? "center" : "right"),
            backgroundRepeat: "no-repeat",
            // iOS Safari ignores fixed backgrounds, so parallax only applies on desktop
            backgroundAttachment: parallax
              ? { xs: "scroll", md: "fixed" }
              : "scroll",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "5vh",
          }}
        >
          {logoSolution && (
            <MKBox
              height={{ xs: "15vh", md: "25vh" }}
              minWidth={{ xs: "fit-content", lg: "fit-content" }}
              bgColor="transparent"
              borderRadius="15px"
            >
              <img src={logoSolution} alt="Logo" className="imagenLogo"></img>
            </MKBox>
          )}
          {desc && (
            <MKBox
              minHeight={logoSolution ? "7vh" : "10vh"}
              bgColor={whitewash ? "transparent" : "rgba(120, 120, 120, 0.9)"}
              borderRadius="10px"
              // minWidth="10vw"
              width={{ xs: "95%", lg: "auto" }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingX: "2vw",
              }}
            >
              <MKTypography
                fontSize={{
                  xs: "1.1rem",
                  md: logoSolution ? "2rem" : "2.5rem",
                }}
                sx={{
                  textTransform: "uppercase",
                  textAlign: "center",
                  position: "relative",
                  color: whitewash ? "#344767 !important" : "white !important",
                  fontWeight: "bold",
                  ...(whitewash && {
                    textShadow:
                      "-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff, 0 0 12px rgba(255, 255, 255, 0.9)",
                  }),
                }}
                className="texto-header"
              >
                {desc}
              </MKTypography>
            </MKBox>
          )}
        </MKBox>
        {!soloHeader && (
          <>
            <MKBox
              className="flex-contenido"
              flexDirection={{
                xs: "column",
                md: ordenFlex ? "row" : "row-reverse",
              }}
            >
              <div className="box-contenido">
                <div className="flex-tituloc">
                  <MKTypography
                    className={textoNegro ? "tituloc" : "titulocW"}
                    sx={{ color: ordenTitulo ? colorTexto : "#595456" }}
                  >
                    {textoColor}
                  </MKTypography>
                  <MKTypography
                    className={textoColor ? "tituloc" : "titulocW"}
                    sx={{ color: ordenTitulo ? "#595456" : colorTexto }}
                  >
                    {textoNegro}
                  </MKTypography>
                </div>
                <div className="box-texto">
                  <MKTypography
                    className={textoColor ? "texto-boxc" : "texto-boxcJ"}
                    fontSize={!textoColor && !textoNegro && "1.7rem !important"}
                    dangerouslySetInnerHTML={{ __html: textoContenido }}
                  >
                    {/* {textoContenido} */}
                  </MKTypography>
                </div>
              </div>
              <div className="box-contenido">
                <img src={imagenContenido} className="imagenLogo"></img>
              </div>
            </MKBox>

            {/* TIAGO BOXXXXXXXXXXXXXXXXXX */}
            {/* TIAGO BOXXXXXXXXXXXXXXXXXX */}
            {/* TIAGO BOXXXXXXXXXXXXXXXXXX */}
            {
              <MKBox
              // bgColor="red"
              // width="100%"
              >
                {intermediateSection()}
              </MKBox>
            }

            <MKBox
              // bgColor="red"
              // width="100%"
              minHeight="50vh"
            >
              {cardsComponent()}
            </MKBox>
            <MKBox
              // bgColor="red"
              // width="100%"
              justifyContent="center"
              display="flex"
            >
              {lastSection()}
            </MKBox>
          </>
        )}
      </MKBox>
    </>
  );
}
